import { useProperty } from '@eti/providers';
import type { BrandedFareInfo, Maybe } from '@eti/schema-types';
import type { SearchOnResultPageMarketingCarrier } from '../../pages/result/models';

type BrandedFareNamesProps = {
  brandedFareInformation: Maybe<BrandedFareInfo> | undefined;
  marketingCarrier: SearchOnResultPageMarketingCarrier;
};

export const useBrandedFareName = ({
  brandedFareInformation,
  marketingCarrier,
}: BrandedFareNamesProps) => {
  const { p } = useProperty();
  const brandedFaresEnabledForCarriersList = p('BrandedFares.ShowForIncluded.Carriers.List');
  const shouldShowBrandedFare = brandedFaresEnabledForCarriersList?.includes(
    marketingCarrier?.code,
  );
  let fareName = brandedFareInformation?.name;
  if (shouldShowBrandedFare) {
    const brandedFareInfoNameList = fareName?.toLowerCase().split(' ');
    const formattedBrandedFareInfoNameList = brandedFareInfoNameList?.map(
      (name) => name.charAt(0).toUpperCase() + name.slice(1),
    );
    fareName = formattedBrandedFareInfoNameList?.join(' ');
  }
  const brandedFareName = shouldShowBrandedFare && fareName;
  return brandedFareName || null;
};
